export default "__VITE_ASSET__qls_aanq__";